import {
  SYNC_ASSESSMENT_CONFIGS,
} from '../actions/types';

//user state can be false (if not logged in), authenticating (if currently fetching user), or the user{} object

const DEFAULT_STATE = {
  loading: true,
  error: null,
  data: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case SYNC_ASSESSMENT_CONFIGS:
      return {
        ...state,
        loading: false,
        data: action.payload
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/assessmentConfigsReducer.js